import config from '../config';
import { apiPost } from './apiAuth';

export const TOPICS_SUBTOPICS_SESSION_PREFIX = 'topics_subtopics_';

export function getTopicsSubtopicsSessionKey(subjectId) {
  return `${TOPICS_SUBTOPICS_SESSION_PREFIX}${subjectId}`;
}

/**
 * Read cached topics/subtopics for a subject from sessionStorage.
 * Supports both stored shapes: topics[] and { topics: [] }.
 */
export function readTopicsSubtopicsFromSession(subjectId) {
  if (!subjectId) return null;
  try {
    const raw = sessionStorage.getItem(getTopicsSubtopicsSessionKey(subjectId));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    const topics = Array.isArray(parsed) ? parsed : parsed?.topics;
    if (!Array.isArray(topics) || topics.length === 0) return null;
    return topics;
  } catch {
    return null;
  }
}

export function writeTopicsSubtopicsToSession(subjectId, topics) {
  if (!subjectId || !Array.isArray(topics) || topics.length === 0) return;
  try {
    sessionStorage.setItem(
      getTopicsSubtopicsSessionKey(subjectId),
      JSON.stringify(topics)
    );
  } catch {
    // ignore quota / private-mode failures
  }
}

/**
 * Return topics+subtopics for a subject.
 * Uses sessionStorage first; calls API only on cache miss (or forceRefresh).
 */
export async function getTopicsSubtopicsBySubject(
  subjectId,
  { forceRefresh = false } = {}
) {
  if (!subjectId) return [];

  if (!forceRefresh) {
    const cached = readTopicsSubtopicsFromSession(subjectId);
    if (cached) return cached;
  }

  const response = await apiPost(
    `${config.API_BASE_URL}/api/content_creation/topics_subtopics_by_subject/`,
    { subject_id: subjectId }
  );
  const topics = response?.data?.topics || [];
  writeTopicsSubtopicsToSession(subjectId, topics);
  return topics;
}
